import { ElementRef, HostListener, Directive, Input, NgModule } from '@angular/core';

var MAX_LOOKUP_RETRIES = 3;
var Autosize = (function () {
    function Autosize(element) {
        this.element = element;
        this.retries = 0;
        if (this.element.nativeElement.tagName !== 'TEXTAREA') {
            this._findNestedTextArea();
        }
        else {
            this.textAreaEl = this.element.nativeElement;
        }
    }
    Autosize.prototype.onInput = function (textArea) {
        this.adjust();
    };
    Autosize.prototype._findNestedTextArea = function () {
        var _this = this;
        this.textAreaEl = this.element.nativeElement.getElementsByTagName('TEXTAREA')[0];
        if (!this.textAreaEl) {
            if (this.retries >= MAX_LOOKUP_RETRIES) {
                console.warn('angular2-autosize: textarea not found');
            }
            else {
                this.retries++;
                setTimeout(function () {
                    _this._findNestedTextArea();
                }, 100);
            }
        }
    };
    Autosize.prototype.ngAfterContentChecked = function () {
        this.adjust();
    };
    Autosize.prototype.adjust = function () {
        if (this.textAreaEl) {
            var area = this.textAreaEl;
            area.style.overflow = 'hidden';
            area.style.height = 'auto';
            var lineHeight = this._getLineHeight();
            var height = area.scrollHeight;
            var rowsCount = height / lineHeight;
            if (this.minRows && this.minRows >= rowsCount) {
                area.style.overflow = 'auto';
                height = this.minRows * lineHeight;
            }
            else if (this.maxRows && this.maxRows <= rowsCount) {
                area.style.overflow = 'auto';
                height = this.maxRows * lineHeight;
            }
            area.style.height = height + "px";
        }
    };
    Autosize.prototype._getLineHeight = function () {
        var lineHeight = parseInt(this.textAreaEl.style.lineHeight, 10);
        if (isNaN(lineHeight)) {
            var fontSize = window.getComputedStyle(this.textAreaEl, null).getPropertyValue('font-size');
            lineHeight = Math.floor(parseInt(fontSize.replace('px', '')) * 1.5);
        }
        return lineHeight;
    };
    return Autosize;
}());
Autosize.decorators = [
    { type: Directive, args: [{
                selector: '[autosize]'
            },] },
];
Autosize.ctorParameters = function () { return [
    { type: ElementRef, },
]; };
Autosize.propDecorators = {
    "minRows": [{ type: Input },],
    "maxRows": [{ type: Input },],
    "onInput": [{ type: HostListener, args: ['input', ['$event.target'],] },],
};
var AutosizeModule = (function () {
    function AutosizeModule() {
    }
    AutosizeModule.forRoot = function () {
        return { ngModule: AutosizeModule, providers: [] };
    };
    return AutosizeModule;
}());
AutosizeModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    Autosize
                ],
                exports: [
                    Autosize
                ]
            },] },
];

export { AutosizeModule, Autosize };
//# sourceMappingURL=ngx-autosize.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/ngx-autosize/esm5/ngx-autosize.js
// module id = 585
// module chunks = 112